import { pageUrl } from '@/constants/url'
import { lazy } from 'react'
import { Route } from 'react-router-dom'

const Error404Page = lazy(() => import('./404'))
const Error498Page = lazy(() => import('./498'))
const Error403Page = lazy(() => import('./403'))
const Error402Page = lazy(() => import('./402'))

export const errorsRoutes = () => {
  return (
    <>
      <Route path={pageUrl.error498} element={<Error498Page />} />
      <Route path={pageUrl.error498} element={<Error498Page />} />
      <Route path={pageUrl.error403} element={<Error403Page />} />
      <Route path={pageUrl.error402} element={<Error402Page />} />
      <Route path="*" element={<Error404Page />} />
    </>
  )
}
